import { render, staticRenderFns } from "./BriqRadioButtons.vue?vue&type=template&id=9565b984&scoped=true&lang=pug&"
import script from "./BriqRadioButtons.vue?vue&type=script&lang=js&"
export * from "./BriqRadioButtons.vue?vue&type=script&lang=js&"
import style0 from "./BriqRadioButtons.vue?vue&type=style&index=0&id=9565b984&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9565b984",
  null
  
)

export default component.exports